/* Slanje standardnih eventova ka Meta Pixelu (fbq se učitava iz
   snippeta u index.html). Guard je obavezan jer ad-blockeri često
   blokiraju fbevents.js pa fbq ne postoji. */
export const trackPixel = (event, params) => {
  if (window.fbq) {
    window.fbq("track", event, params);
  }
};

/* Meta traži value kao broj (npr. 2200), currency posebno. */
export const productParams = (product, quantity = 1) => ({
  content_ids: [String(product.id)],
  content_type: "product",
  content_name: product.name,
  value: (product.salePrice || product.price) * quantity,
  currency: "RSD",
});
